// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

class AddLead extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      lead:{
        name:'', 
        email: '',
        mobile_no: '',
        venue: '',
        game_type: '',
        source: '',
        sub: '',
        status: '',
        comments: '',

      },
                  
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    
  }

  componentDidMount() {
    this.getFixtureList();
    this.getStatusList();
    this.getSourceList();
  }
  getStatusList(){
    const url = `${getLocationOrigin()}/lead/create_lead_status/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ statuses: data.statuses}))
       .catch(error => error);

  }
  getSourceList(){
    const url = `${getLocationOrigin()}/lead/create_lead_source/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ sources: data.source}))
       .catch(error => error);

  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_types: data.game_type}))
       .catch(error => error);
  }

  
  postaddLead(data, props) {
    if(!data.venue){data.venue=this.state.venues[0].id}
    if(!data.game_type){data.game_type=this.state.game_types[0].pk}
    if(!data.status){data.status = this.state.statuses[1].id}
    if(!data.source){data.source = this.state.sources[0]}  
    if(!data.sub){data.sub = "Eagleeye"}
    else{data.sub = data.sub + 'Eagleeye'}  
    const url = `${getLocationOrigin()}/lead/create_lead/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'customer_name': data.name,
                        'customer_mobile': data.mobile_no,
                        'customer_email': data.email,
                        'customer_preferred_location': data.venue,
                        'customer_game_type': data.game_type,
                        'customer_lead_status': data.status,
                        'customer_source': data.source,
                        'customer_sub_source': data.sub,
                        'customer_comment': data.comments,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.lead);
    new_selected_one[name] = event.target.value
    this.setState({lead: new_selected_one});
  }


  // handleOpen = () => {
  //   this.setState({dialog_open: true});
  // };

  // handleClose = () => {
  //   this.setState({dialog_open: false});
  // };

  handleSubmit(event) {
    console.log(this.state.lead);
    event.preventDefault();
    this.postaddLead(this.state.lead, this.props);
  }

  

  render() {

    return(
      <div style={styles.container}>
        <div className="row col-md-10 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center', color: '#FFFFFF'}}>Add Lead</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Name
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="name" className="form-control"
                  placeholder="Name " value={this.state.lead.name} onChange={this.handleChange}/>
              </div>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Mobile
              </div>
              <div className="col-md-6 input-group">
                <input type="tel" name="mobile_no" className="form-control" size="10"
                  placeholder="Mobile" value={this.state.lead.mobile_no} onChange={this.handleChange}/>
              </div>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Email
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="email" className="form-control"
                  placeholder="Email" value={this.state.lead.email} onChange={this.handleChange}/>
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                { this.state.venues ?
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                  :
                  <option>Loading....</option>
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                { this.state.game_types ? 
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                  :
                  <option>Loading...</option>
                }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Status
              </div>
              <select name="status" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                { this.state.statuses ? 
                  this.state.statuses.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.status}</option>
                  ))
                  :
                  <option>Loading...</option>
                }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Source
              </div>
              <select name="source" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                { this.state.sources ? 
                  this.state.sources.map((x, index) => (
                  <option key={index} value={x}>{x}</option>
                  ))
                  :
                  <option>Loading...</option>
                }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Sub-Source
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="sub" className="form-control"
                  placeholder="Subsource" value={this.state.lead.sub} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Comments
              </div>
              <div className="col-md-6 input-group">
                <textarea rows="4" cols="33" id="comments" name="comments" placeholder="Comments" onChange={this.handleChange}>
                {this.state.lead.comments}
                </textarea>
              </div>
            </div>
            <div  className="col-md-6" style={{marginLeft: '320px', marginTop: '5px'}}>
                <button className="btn btn-default" style={{backgroundColor: '#FDD60B', padding: '2%', borderColor: '#FDD60B', borderWidth: '2px', width: '200px', alignSelf: 'center'}}
                type="button" onClick={this.handleSubmit}><span style={{color: '#000000'}}>ADD</span></button>
                                  
            </div>

            
          </form>
        </div>
      </div>
    );
  }
}

export default AddLead;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addlead/index.js